<div class="team-container">
  <h2 class=" text-center fw-medium team-title"  style="font-size: 38px; letter-spacing: 0.5px; font-family: 'Poppins', sans-serif;">Team List</h2>

  <div class="d-flex justify-content-center mt-3">
      <button class= "btn btn-user rounded-pill px-4 py-2 fw-bold d-flex align-items-center justify-content-center mb-4 px-5" data-bs-toggle="modal"
      data-bs-target="#addTeamModal">
      + Add New Team
    </button></div>

  <div class="table-responsive d-flex justify-content-center mt-0"> 
    <table class="table table-hover align-middle text-center border rounded-4 w-auto fs-6 ">
      <thead class="table-light fs-5">
        <tr>
          <th class="border-end">Team Name</th>
          <th class="border-end">Total Members</th>
        </tr>
      </thead>

      <tbody *ngIf="teams && teams.length > 0">
        <tr *ngFor="let team of teams" style="cursor: pointer;">
          <td class="border-end"><a (click)="goToTeam(team.teamId)" class="text-decoration-none">
    {{ team.name }}
  </a></td>
          <td class="border-end">{{ (team.users.length||0)}}</td>
        </tr>
      </tbody>
    </table>
  </div>

<div class="modal fade" id="addTeamModal" tabindex="-1" aria-labelledby="addTeamModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="addTeamModalLabel">Add Team</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <app-add-team (teamAdded)="onTeamAdded($event)"></app-add-team>
      </div>

    </div>
  </div>
</div>

<div class="toast-container position-fixed top-0 end-0 p-3">
  <div #teamToast class="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
         Team Added Successfully!
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  </div>
</div>
